import axios from "axios";

/* let backendHost = process.env.NODE_ENV === 'production'
  ?'https://www.waizmanntabelle.de'
  :'http://loc.waizmanntabelle.de'
 */
var baseURL = "";
// You can use your own logic to set your local or production domain

if (window.location.hostname == "localhost") {
  baseURL = "https://loc-vq.clearment.de/api";
}

if (window.location.hostname == "loc-vq.clearment.de") {
  baseURL = "/api";
}
if (window.location.hostname == "vq.clearment.de") {
  baseURL = "http://vq.clearment.de/api";
}
if (window.location.hostname == "www.clearment.de") {
  baseURL = "https://www.clearment.de/api";
}

export default axios.create({
  baseURL: baseURL,
  withCredentials: true,
});
